// removed by extract-text-webpack-plugin
module.exports = {"vadpLogin":"vadpLogin___1j4as","container":"container___72KCQ","title":"title___3fRQj","form":"form___21LbN","autofill-fix":"autofill-fix___eEp8y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginBJZX/index.less
// module id = 347
// module chunks = 0